import { render, staticRenderFns } from "./ImageAllDoc.vue?vue&type=template&id=1fbdd2c6&"
import script from "./ImageAllDoc.vue?vue&type=script&lang=js&"
export * from "./ImageAllDoc.vue?vue&type=script&lang=js&"
import style0 from "./ImageAllDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports